import * as React from 'react';
import './style.less';

const clsPrefix = 'new-plan-table';
const TableMenu = ({ dataSource }) => {
  return (
    <section className={`${clsPrefix}__table-menu`}>
      {dataSource.map(table => (
        <div className="table-menu-item">
          <a href={`#${table.id}`}>{table.name}</a>
          <div className="status-dot" />
        </div>
      ))}
      <div className="progress-line" style={dataSource.length < 1 ? { display: 'none' } : {}} />
    </section>
  );
};

export default TableMenu;
